import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * User score detail layout
 */
export default function UserScoreLayout() {
  const router = useRouter();
  const navigation = useNavigation();
  const colors = useThemeColors();

  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      router.replace("/scores");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: colors.primary,
        headerTitleStyle: { color: colors.text },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color={colors.primary} />
          </Pressable>
        ),
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="[id]" options={{ title: "Gebruiker Score" }} />
    </Stack>
  );
}

